import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';

export const InteractiveCardRoot = styled(Card, {
  name: 'AFInteractiveCard',
  shouldForwardProp: prop => prop !== 'disabled' && prop !== 'selected'
})(({ theme, selected, disabled }) => {
  const selectedBorder = `2px solid ${theme.palette.primary.main}`;
  const selectedStyles = {
    border: selectedBorder,
    backgroundColor: theme.palette.action.selected
  };

  return {
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    ...(disabled && {
      color: theme.palette.text.disabled,
      pointerEvents: 'none'
    }),
    ...(selected && selectedStyles),
    '&:hover': {
      boxShadow: theme.shadows[4],
      cursor: 'pointer'
    },
    // According to UX review focus state should be as active state
    '&:focus-visible, &:active': {
      border: selectedBorder
    }
  };
});
